export default "__VITE_ASSET__xioVoT0dzCNlR661xM0qpw__"